<div *ngFor="let socialMediaField of socialMediaSettings.SocialMediaFields">
  <div class="col-sm-6" *ngIf="socialMediaField.Visible">
    <label>
      {{ socialMediaField.Name }}
    </label>
  </div>
</div>
